import React from 'react';
import './style.css';
// import { NavLink } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

import Logo from '../../assets/images/StarlifeLogo.png';
import StayConnected from '../StayConnectedSection';

// import { BsWhatsapp } from 'react-icons/bs';
// import { RiFacebookCircleLine } from 'react-icons/ri';
// import { CgInstagram } from 'react-icons/cg';
// import { PiLinkedinLogoBold } from 'react-icons/pi';
import WinnerBanner from '../../assets/images/winner-banner-2025.png';
export default function Footer() {
	return (
		<div className='footer'>
			<div className='col-1'>
				<img src={Logo} alt='logo' />
				<div>
					<a href='tel:+13059157737'>
						<h3>(305) 915-7737</h3>
					</a>
					<a href='mailto:Info@thestarlifegroup.com'>
						<h3>Info@thestarlifegroup.com</h3>
					</a>
				</div>
			</div>
			<div className='col-2'>
				<a
					href='https://luxurylifestyleawards.com/winners/residential-development/starlife-group/'
					target='_blank'
					rel='noopener noreferrer'
				>
					<img src={WinnerBanner} alt='Winner Banner' />
				</a>
			</div>
			<div className='col-3'>
				<StayConnected />
			</div>
		</div>
	);
}
